import Box from "@mui/material/Box";
import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import AllStaff from "../components/staff";
import { getAllStaffPermissions } from "../features/staff/staffSlice";
import { StaffListToolbar } from "../components/staff/staff-screen-toolbar";
import { ColorPallet } from "../utils/colorPallet";
import LoadingSpinner from "../components/common/Loading";
import ErrorToster from "../components/common/ErrorToster";
import AppSnackbar from "../components/common/AppSnackbar";
import SearchField from "../components/common/SearchField";
import { initialDropdownValues } from "../utils/constants";
const StaffScreen = () => {
  const dispatch = useAppDispatch();
  const {
    registerStaffPermissionMessage,
    staffStatusMessage,
    editStaffDataMessage,
  }: any = useAppSelector((state) => state.staff);
  const [openErrorToast, setOpenErrorToast] = useState<any>(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSnackEditbar, setOpenSnackEditbar] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const pharmacyID: any = localStorage?.getItem("pharmacyId");
  const { isStaffPermissionsLoading }: any = useAppSelector(
    (state) => state.staff
  );

  const [filterValuesParents, setFilterValuesParent] = useState<{
    dropdown1: string | null;
    dropdown2: string | null;
    dropdown3: string | null;
    dropdown4: string | null;
    date: string | undefined;
  }>(initialDropdownValues);

  const handleSearchChange = useCallback(
    (searchQuery: string) => {
      setSearchQuery(searchQuery);
    },
    [searchQuery]
  );

  const GetAllStaffPermissions = useCallback(() => {
    dispatch(getAllStaffPermissions(pharmacyID));
  }, [dispatch]);

  useEffect(() => {
    if (pharmacyID) {
      GetAllStaffPermissions();
      setFilterValuesParent(initialDropdownValues);
    }
  }, [pharmacyID, GetAllStaffPermissions]);

  return (
    <>
      {/* <Box sx={{ p: 3, fontSize: "24px", fontWeight: "bold" }}>
        List of Staff Members
      </Box> */}
      {isStaffPermissionsLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "75vh",
          }}
        >
          <LoadingSpinner />
        </Box>
      ) : (
        <Box
          sx={{
            margin: 1,
            backgroundColor: ColorPallet.bgcolor,
            borderRadius: "5px",
            minHeight: {
              xs: "auto",
              sm: "80vh",
              
            },
            my: "1.2%",
          }}
        >
          <Box
            sx={{
              mt: { xs: 1, sm: 0 },
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: { xs: "start", sm: "space-between" },
              alignItems: "center",
              gap: 2,
              px: 1,
            }}
          >
            <SearchField
              width={292}
              searchQuery={searchQuery}
              setSearchQuery={handleSearchChange}
              title={"Search Name"}
              // height={"44px"}
            />
            <StaffListToolbar
              GetAllStaffPermissions={GetAllStaffPermissions}
              setOpenErrorToast={setOpenErrorToast}
              setOpenSnackbar={setOpenSnackbar}
            />
          </Box>

          <Box sx={{ px: 1, width: "100%" }}>
            <AllStaff
              GetAllStaffPermissions={GetAllStaffPermissions}
              pharmacy_id={pharmacyID}
              setOpenSnackEditbar={setOpenSnackEditbar}
              setOpenErrorToast={setOpenErrorToast}
              searchQuery={searchQuery}
              requiredFilters={filterValuesParents}
            />
          </Box>
        </Box>
      )}
      <ErrorToster
        message={[
          registerStaffPermissionMessage,
          staffStatusMessage,
          editStaffDataMessage,
        ].find(Boolean)}
        open={openErrorToast}
        handleClose={() => setOpenErrorToast(false)}
      />

      <AppSnackbar
        message="Successfully Added!"
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
      />
      <AppSnackbar
        message="Successfully Updated!"
        open={openSnackEditbar}
        handleClose={() => setOpenSnackEditbar(false)}
      />
    </>
  );
};

export default StaffScreen;
